import type { ExternalTableSchema } from '@packages/table-builder';

export const bankAccountTable: ExternalTableSchema = {
  metadata: {
    title: 'Bank Account',
    entity: 'Banks',
    description: 'List of bank accounts on Wealthlane system for tax withholding and exercises.',
  },

  dataSource: {
    endpoint: '/api/finance-integration/api/app/company-bank/company-bank-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
  },

  columns: [
    {
      field: 'accountName',
      header: 'Bank Account Details',
      type: 'couple',
      sortable: true,
      width: 200,
      couple: {
        titleField: 'bankName',
        subtitleField: 'accountName',
        showTag: true,
      },
    },
    {
      field: 'accountNumber',
      header: 'Account Number',
      type: 'mask',
      width: 200,
      align: 'center',
      mask: { valueField: 'accountNumber', format: 'partial' },
    },
    {
      field: 'routingNumber',
      header: 'Routing Number',
      type: 'mask',
      width: 180,
      align: 'center',
      mask: { valueField: 'routingNumber', format: 'full' },
    },
    {
      field: 'status',
      header: 'Status',
      type: 'badge',
      sortable: true,
      width: 180,
      align: 'center',
      badge: {
        statusMap: {
          Verified: 'success',
          'Pending Broker': 'info',
          'Broker Received': 'primary',
          Rejected: 'error',
        },
        displayMap: { 'Pending Broker': 'Pending' },
        defaultVariant: 'info',
      },
    },
    {
      field: 'bankPurpose',
      header: 'Account Purpose',
      type: 'text',
      width: 200,
    },
    {
      field: 'isDefaultAccount',
      header: 'Default Account',
      type: 'badge',
      sortable: true,
      width: 200,
      align: 'center',
      badge: {
        statusMap: { true: 'info', false: 'default' },
        defaultVariant: 'info',
      },
      conditionalValues: { true: 'Yes', false: '-' },
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_BANK_ACCOUNT', label: 'View' },
      { id: 'SET_DEFAULT_BANK_ACCOUNT', label: 'Set as Default Account' },
      { id: 'CHANGE_PURPOSE_BANK_ACCOUNT', label: 'Change Account Purpose' },
      { id: 'DELETE_BANK_ACCOUNT', label: 'Delete', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_BANK_ACCOUNT',
        label: 'Add Bank Account',
        icon: 'add_circle_outline',
      },
    },
  },

  features: {
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: {
      persistenceKey: 'Bank Account',
      resizable: true,
      reorderable: true,
    },
  },
};
